(function() {
    let element = document.querySelector('.language-dropdown');

    if (element === null) {
        return;
    }

    element.addEventListener('click', (e) => {
        if (e.target.classList.contains('language-dropdown_link') || e.target.classList.contains('arrow-down')) {
            e.preventDefault();

            e.currentTarget.classList.toggle('language-dropdown-active');

            e.stopPropagation();
        }
    });
})();